CT = (function(ns){
	
	/**
	 * Background Search - This module helps you to fetch server-content in the background
	 * 
	 *  options:
	 *  url: api url to fetch server content
	 *  ajaxBeforeSend: function to access the beforeSend function of BgSearch's $.ajax call.
	 *  ref: the identifier for this Bgsearch-object which is attached to the $field Node.
	 *  $field: the field to which this "Background Search" is dependent on,  and the BgSearch object will be attached to this field for reference. 
	 *  
	 **/
	
	/**
	
	INITIALIZATION
	new CT.BgSearch({
		$field:$("#Tags"),
		url:"/hotels/jsonservice/hotel-content?city={{city}}&state={{state}}&country={{country}}",
		ref: "hotelContentBgSearch"
	});

	TRIGGER BACKGROUND SEARCH
	$("#Tags")[0].hotelContentBgSearch.set({city:"Bangalore",state:"Karnataka",country:"IN"});

	GET DATA
	$("#Tags")[0].hotelContentBgSearch.get({city:"Bangalore",state:"Karnataka",country:"IN"}, function(content){
		if(content && content.data){
			alert("success , " + content.data.length);
		}else{
			alert("No data found , " + content.status);
		}
	});
	
	**/
	
	function BgSearch(options){
		/*
		 * Private Properties and methods
		 */
		var model = {};
		var modelStatus = {};
		var modelCallbacks = {};
		var self = this;
		var getKey = function(paramsHash){
			var key;
			if(paramsHash._id){
				key = paramsHash._id
			}else{
				key = _.values(paramsHash).join("_");
			}
			return key;
		};

		/*
		 * Public Properties and methods
		 */
		
		this.model= model;
		/*
		 * args 0 - paramHash
		 * args 1 - params for ajaxBeforeSend [optional]
		 * args 1(or)2 - callBack
		 *
		 * Eg: get({paramHash} , function(){callback});
		 * Eg: get({paramHash} , {paramsAjaxBeforeSend} , function(){callback});
		 */
		this.set = function(){
			var paramsHash , ajaxBeforeSendParams , callBack , key , ajaxBeforeSend;
			
			if(options.ajaxBeforeSend){
				paramsHash = arguments[0];
				ajaxBeforeSendParams = arguments[1];
				callBack = arguments[2];
				ajaxBeforeSend = function(xhr){
					options.ajaxBeforeSend(xhr, arguments[1].url, ajaxBeforeSendParams);
				} ; 
			}else{
				paramsHash = arguments[0];
				callBack = arguments[1];
				ajaxBeforeSend = function(){};
			}
			//Adding the following check for PAH with CC
			if(window.countryCode=="in" && paramsHash.country=="IN" && window.product!="B2B"){
                 options.url+="&pahCCRequired="+true;
			}
			key = getKey(paramsHash);
			
			delete paramsHash._id;
			
			if(!modelStatus[key] || modelStatus[key] == "failed"){
				
				var url  = options.url;
				_.each(paramsHash, function(value,key){
					url = url.replace("{{"+ key +"}}", value);
				});
				
				modelStatus[key] = "progress";
				$.ajax({
					url : url,
					type: "GET",
					beforeSend: ajaxBeforeSend
					}).done(function(data,status,responseObj){
						
						data = (typeof data == "string")?JSON.parse(data):data;
						modelStatus[key] = "done";
						if(options.onSet){
							data = options.onSet(data);
						}
						
						model[key] = data;
						
						if(callBack){
							callBack({data:data});
						}
						if(modelCallbacks[key]){
							_.each(modelCallbacks[key],function(_callBack){
								_callBack({data:data});
							});
							delete modelCallbacks[key];
						}
						
						
				}).fail(function(responseObj){
					modelStatus[key] = "failed";
					if(callBack){
						callBack({status:responseObj.status});
					}
				})
			}else if(modelStatus[key] == "progress"){
				//store the callback in a callbacks cache;
				(modelCallbacks[key] || (modelCallbacks[key]=[])).push(callBack);
			}
		};
		
		/*
		 * args 0 - paramHash
		 * args 1 - params for ajaxBeforeSend [optional]
		 * args 1(or)2 - callBack
		 *
		 * Eg: get({paramHash} , function(){callback});
		 * Eg: get({paramHash} , {paramsAjaxBeforeSend} , function(){callback});
		 */
		this.get = function(){
			
			var paramsHash, ajaxBeforeSendParams , callBack , key;
			
			if(options.ajaxBeforeSend){
				paramsHash = arguments[0];
				ajaxBeforeSendParams = arguments[1];
				callBack = arguments[2];
			}else{
				paramsHash = arguments[0];
				callBack = arguments[1];
			}
			key = getKey(paramsHash);
			 
			if(modelStatus[key] == "done"){
				if(callBack)
					callBack({data:$.extend(true,{},model[key])});
			}else if((!modelStatus[key] || modelStatus[key] == "failed")){
				this.set.apply(this, arguments);
			}else if(modelStatus[key] == "progress"){
				//store the callback in a callbacks cache;
				(modelCallbacks[key] || (modelCallbacks[key]=[])).push(callBack);
			}
		};
		
		
		
		//init
		(function(){
			if(options.url || options.$field)	
				options.$field[0][options.ref] = self;
		})();
	}



	ns.BgSearch = BgSearch;

	return ns;	//return ns.BgSearch;
})(CT || {});



